/* Il blocco Scalapay widget-block sulla scheda prodotto mette in coda la
   propria configurazione in window.scalapayConfig, ma sulle pagine prodotto
   lo script dell'app che dovrebbe leggere la coda e creare l'elemento
   <scalapay-widget> non arriva a processarla in tempo (probabile timing
   dell'app stessa). Qui elaboriamo noi la coda, creando il widget al posto
   giusto se non e' gia' presente. */
(function () {
  function processScalapayQueue() {
    if (!window.scalapayConfig || !window.scalapayConfig.length) return;
    window.scalapayConfig.forEach(function (entry) {
      var scriptEl = entry[0];
      var config = entry[1];
      if (!scriptEl || !scriptEl.parentNode || scriptEl.dataset.scalapayProcessed) return;
      var nextEl = scriptEl.nextElementSibling;
      if (nextEl && nextEl.tagName === 'SCALAPAY-WIDGET') return;
      scriptEl.dataset.scalapayProcessed = 'true';
      var widget = document.createElement('scalapay-widget');
      Object.keys(config).forEach(function (key) {
        widget.setAttribute(key, config[key]);
      });
      scriptEl.parentNode.insertBefore(widget, scriptEl.nextSibling);
    });
  }

  function scheduleProcessing() {
    setTimeout(processScalapayQueue, 300);
    setTimeout(processScalapayQueue, 1200);
  }

  if (document.readyState === 'complete') {
    scheduleProcessing();
  } else {
    window.addEventListener('load', scheduleProcessing);
  }
})();
